import React from 'react';
import { ITEM_IN_THE_CART, ITEMS_IN_THE_CART } from '../data/Localization';

/**
 * Renders a message indicating the number of items added to the cart.
 *
 * @param {Object} props - The component props.
 * @param {number} props.qty - The quantity of items added to the cart.
 * @param {boolean} props.animateOn - Flag indicating whether to animate the message.
 * @returns {JSX.Element|null} The rendered AddToCartMessage component.
 */
const AddToCartMessage = (props) => {
	if (!props.qty || props.qty < 1) {
		return null;
	}

	let message = props.qty > 1 ? ITEMS_IN_THE_CART : ITEM_IN_THE_CART;
	return (
		<div className={`prc__items-added-update font-size--2 updated ${props.animateOn ? 'fade-in' : ''}`}>
			<p>
				<span className="icon icon-ui-check-mark icon-ui-flush"></span>
				{props.qty} {message}
			</p>
		</div>
	);
};

export default AddToCartMessage;
